import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils';

import {
  ALERTS_PENDING,
  ALERTS_SUCCESS,
  ALERTS_ERROR,
} from '../types';

export const getAlerts = ({ headerAlert = false } = {}) => async (dispatch, getState) => {
  const key = headerAlert ? 'headerAlert' : 'alerts';
  const { alerts } = getState();

  const currentStatus = alerts[key]?.status;

  // Prevent duplicate requests
  if (currentStatus === FetchStatus.LOADING || currentStatus === FetchStatus.PENDING) {
    return;
  }

  dispatch({
    type: ALERTS_PENDING,
    payload: {
      key,
    },
  });

  try {
    const query = headerAlert ? '?header_alert=1' : '';

    const res = await axios.get(
      `${getNodeApiDomain()}/dor/drupal/alerts${query}`,
    );

    const headerAlertData = res?.data?.filter((a) => a?.header_alert) || [];

    dispatch({
      type: ALERTS_SUCCESS,
      payload: {
        key,
        data: headerAlert ? headerAlertData[headerAlertData.length - 1] : res.data,
      },
    });
  } catch (error) {
    dispatch({
      type: ALERTS_ERROR,
      payload: {
        key,
        error,
      },
    });
  }
};
